// ATLAS — sidebar categories, docs-style. Category navigation on the left
// with per-category question counts, hairline accordion list on the right.
// All category panes are rendered; inactive ones carry the `hidden`
// attribute and the tabs runtime swaps them (.fq-tab / .fq-pane [data-cat]).
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span>${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const atlas = {
    id: 'atlas',
    name: 'Atlas',
    tag: 'Sidebar categories',
    styleTag: 'Docs-style',
    description: 'A docs-style layout: category navigation on the left with question counts, answers on the right. The right choice for large, structured FAQs.',
    layout: 'tabs',
    defaultAccent: '#312d85',
    darkDefault: false,
    catSupport: 'required',
    features: ['tabs', 'accordion'],
    render(ctx) {
        const tabs = ctx.cats
            .map((c, ci) => `<button class="fq-tab${ci === 0 ? ' fq-tab-on' : ''}" type="button" role="tab" aria-selected="${ci === 0 ? 'true' : 'false'}" data-cat="c${ci}">${c.name}<span class="fq-n">${c.count}</span></button>`)
            .join('\n');
        const panes = ctx.cats
            .map((c, ci) => `<div class="fq-pane" data-cat="c${ci}"${ci === 0 ? '' : ' hidden'}>
${c.items.map((it) => itemHtml(ctx, it)).join('\n')}
</div>`)
            .join('\n');
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  <div class="fq-cols">
    <div class="fq-side" role="tablist" aria-orientation="vertical">
${tabs}
    </div>
    <div class="fq-main">
${panes}
    </div>
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:880px;margin:0 auto}
.FQM .fq-title{margin:0 0 6px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 28px;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-cols{display:flex;flex-wrap:wrap;gap:28px 36px;align-items:flex-start}
.FQM .fq-side{flex:1 1 170px;max-width:240px;display:flex;flex-direction:column;gap:4px}
.FQM .fq-tab{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:10px 14px;border-radius:9px;color:${ctx.v.sub};font-size:14px;font-weight:500}
.FQM .fq-tab .fq-n{font-size:11.5px;opacity:0.6}
.FQM .fq-tab.fq-tab-on{background:${ctx.v.soft};color:${ctx.v.accent};font-weight:600}
.FQM .fq-tab.fq-tab-on .fq-n{opacity:0.75}
.FQM .fq-main{flex:999 1 300px;min-width:0}
.FQM .fq-pane{border-top:1px solid ${ctx.v.border}}
.FQM .fq-acc{border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:18px 2px;font-size:16px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 30px 18px 2px;font-size:15px;line-height:1.6;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default atlas;
